import React from "react";
import { Outlet } from "react-router-dom";
import classes from "./PageContent.module.css";

const PageContent = () => {
  return (
    <div className={classes["muradi-dahb-right"]}>
      <Outlet />
    </div>
  );
};

export default PageContent;
